import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from '@angular/core';
import type { FileFindInterface } from '@zaoblako/shared/modules/storage/dtos/file/file-find.dto';
import { FileService } from '@zaoblako/web/core/services/file.service';
import { FileUpload, FileUploadModule } from 'primeng/fileupload';

@Component({
  standalone: true,
  selector: 'crm-file-uploader',
  templateUrl: 'file-uploader.component.html',
  imports: [CommonModule, FileUploadModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FileUploaderComponent {
  @Input() public label = 'Файлы';
  @Input() public multiple = false;
  @Input() public icon = 'pi-paperclip';
  @Input() public accept = '';
  @Input() public maxFileSize = null;
  @Input() public uploadingLabel = 'Загрузка...';
  @Input() public disabled = false;
  @Input() public isUploadFiles = true;
  @Input() public styleClass: string;
  @Input() public scaleTo: number;

  @ViewChild('fileUpload') public fileUpload: FileUpload;

  @Output() public filesUploaded = new EventEmitter<FileFindInterface[]>();
  @Output() public filesSelected = new EventEmitter<File[]>();

  @Input() public uploadingFiles = false;

  public constructor(private readonly fileService: FileService, private readonly cdRef: ChangeDetectorRef) {}

  /** Открыть системный диалог выбора файла (режим basic). */
  public openFileDialog(): void {
    if (this.uploadingFiles || this.disabled || !this.fileUpload) {
      return;
    }
    this.fileUpload.basicFileInput?.nativeElement?.click();
  }

  public uploadFiles(files: File[]) {
    this.filesSelected.next(files);
    if (this.isUploadFiles) {
      this.uploadingFiles = true;
      this.fileService.upload(files, this.scaleTo ? { scaleTo: this.scaleTo } : null).subscribe({
        next: (uploadedFiles) => {
          this.uploadingFiles = false;
          this.filesUploaded.emit(uploadedFiles);
          this.fileUpload.clear();
          this.cdRef.markForCheck();
        },
        error: () => {
          this.uploadingFiles = false;
          this.fileUpload.clear();
        }
      });
    } else {
      this.fileUpload.clear();
    }
  }
}
